export function getSentryEnv(): string | undefined {
  const runtimeConfig = useRuntimeConfig()
  return runtimeConfig.public.SENTRY_ENV
}
